import { render } from "./ConsignmentSettingsTable.vue?vue&type=template&id=78eb8870&scoped=true"
import script from "./ConsignmentSettingsTable.vue?vue&type=script&lang=js"
export * from "./ConsignmentSettingsTable.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-78eb8870"

export default script